/* Release Theme - v2.0.5 */
const body = document.querySelector('body');
const main = document.querySelector('main');
const windowDynamicEvents = ["scroll", "resize"];
/* DEVICE DETECTOR -- START */
const DeviceDetector = {
getUserAgent() {
return navigator.userAgent.toLowerCase();
},
isMobile() {
const ua = this.getUserAgent();
const mobileRegex = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
return mobileRegex.test(ua) || window.innerWidth <= 750;
},
isTablet() {
const ua = this.getUserAgent();
const tabletRegex = /ipad|android(?!.*mobile)|tablet|kindle|playbook|silk/i;
return tabletRegex.test(ua) || (window.innerWidth > 750 && window.innerWidth <= 990 && 'ontouchstart' in window);
},
isDesktop() {
return !this.isMobile() && !this.isTablet();
},
isIOS() {
const ua = this.getUserAgent();
const iosRegex = /iphone|ipad|ipod/i;
return iosRegex.test(ua);
},
};
/* DEVICE DETECTOR -- END */
/* SECTIONS: HEADER GROUP */
const sectionsOfHeaderGroup = Array.from(
document.querySelectorAll(".shopify-section-group-header-group")
).filter(section => !section.classList.contains("section-header"));
const headerElement = document.querySelector("#header, #shopify-section-main-password-header");
if (headerElement) {
sectionsOfHeaderGroup.push(headerElement);
}
let header = document.querySelector(
"#header, #shopify-section-main-password-header"
);
let announcementBar = document.querySelector(".js-announcement-bar");
let heroBanner = document.querySelector(".hero-banner");
/* SECTION: Header */
const isHeaderSticky = header?.classList.contains('is-sticky');
/* SECTION: Announcement Bars */
const sectionsOfAnnouncementBar = document.querySelectorAll('.section-announcement-bar');
if (sectionsOfAnnouncementBar) {
const setCustomProperty = (property, value) => {
document.documentElement.style.setProperty(property, value);
};
function calcSectionHeights (section) {
const sectionHeights = {
visibleHeight : Math.max(0, Math.min(section.offsetHeight, window.innerHeight - section.getBoundingClientRect().top, section.getBoundingClientRect().bottom)),
height : section.getBoundingClientRect().height
};
return sectionHeights;
}
function updateVisibleHeightsOfAnnouncementBars() {
let totalVisibleHeights = 0;
let totalHeights = 0;
sectionsOfAnnouncementBar.forEach((section) => {
const { height, visibleHeight } = calcSectionHeights(section);
totalHeights += height;
totalVisibleHeights += visibleHeight;
});
setCustomProperty(`--announcement-bars-before-header-heights`, `${parseFloat(totalHeights)}px`);
setCustomProperty(`--announcement-bars-before-header-visible-heights`, `${parseFloat(totalVisibleHeights)}px`);
}
updateVisibleHeightsOfAnnouncementBars();
window.addEventListener('scroll', updateVisibleHeightsOfAnnouncementBars);
window.addEventListener('resize', updateVisibleHeightsOfAnnouncementBars);
}
let productMedia = document.querySelector(".main-product__media"); 
let productMediaSwiper = document.querySelector(
".main-product__media .swiper--product-gallery"
); 
let productCardMedia = document.querySelector(".product-card__media");
let productCardCollections = document.querySelector(".product-card");
document.addEventListener("DOMContentLoaded", function () {
const lazyImages = document.querySelectorAll('img[loading="lazy"]:not(.animation-none)');
lazyImages.forEach(img => {
img.classList.add("lazy");
img.addEventListener("load", function () {
handleLazyLoadedImage(img);
});
if (img.complete) {
handleLazyLoadedImage(img);
}
});
function handleLazyLoadedImage(img) {
if (!img || !img.hasAttribute("loading")) { return; }
setTimeout(() => {
img.removeAttribute("loading");
img.classList.remove("lazy");
}, 100);
}
/* RR 25 Aug 2026 - ROOT CAUSE OF "RANDOM IMAGES FAIL TO RENDER".
   This observer used to call handleLazyLoadedImage() the moment a node was
   INSERTED, not when its image had LOADED. handleLazyLoadedImage() strips
   loading="lazy", so every image injected at runtime (recommendations
   slider, quick-cart drawer, facet re-render, quick view) was turned EAGER
   before it had fetched anything. On a product page that is ~60 images all
   firing at once; Chrome cancels some of the in-flight HTTP/2 streams and a
   cancelled image ends up complete===true with naturalWidth===0, i.e. a
   blank gap. Which image loses the race is random, and a warm cache hides
   it - which is exactly the reported "sometimes one, sometimes another,
   refreshing eventually loads them all".
   MEASURED on live R3.1, /products/venta-lifting-belt:
     server section HTML .................. 62 <img>, 59 loading="lazy"
     after DOMParser + innerHTML insert ... 59 still lazy
     live DOM ............................. 0 of 62 had loading
     cancelled image requests ............. 3 (nextHopProtocol "", 0 bytes)
     broken image ......................... 1, re-request succeeded (1440px)
   DO NOT call handleLazyLoadedImage() on insertion. Wait for load. */
function mutationCallbackForLazyLoadedImage(mutationList, observer) {
for (const mutation of mutationList) {
if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
mutation.addedNodes.forEach(node => {
if (!(node instanceof HTMLElement)) { return; }
const imgs = node.matches && node.matches('img[loading="lazy"]')
  ? [node]
  : Array.prototype.slice.call(node.querySelectorAll('img[loading="lazy"]'));
imgs.forEach(img => {
if (img.complete && img.naturalWidth > 0) {
handleLazyLoadedImage(img);
} else {
img.addEventListener("load", function () { handleLazyLoadedImage(img); }, { once: true });
}
})
})
}
}
};
const observer = new MutationObserver(mutationCallbackForLazyLoadedImage);
observer.observe(
document.querySelector("body"),
{ childList: true, subtree: true }
);
});
document
.querySelectorAll(".hero__inner > .media > video > img")
.forEach(function (el) {
el.setAttribute("loading", "lazy");
el.setAttribute("alt", "Video Cover");
});
document.querySelectorAll(".lazyload").forEach(function (el) {
el.setAttribute("loading", "lazy");
});
windowDynamicEvents.forEach(eventType => {
window.addEventListener(eventType, () => {
setRootCustomProperties();
});
});
setRootCustomProperties();
if (Shopify.designMode) {
window.addEventListener("shopify:section:load", setRootCustomProperties);
window.addEventListener("shopify:section:select", setRootCustomProperties);
}
window.addEventListener("shopify:section:load", function () {
header = document.querySelector(
"#header, #shopify-section-main-password-header header"
);
announcementBar = document.querySelector(".js-announcement-bar");
productCardMedia = document.querySelector(".product-card__media");
});
function getCoordinates(element) {
const rect = element.getBoundingClientRect();
return {
top: rect.top + window.scrollY,
right: rect.right + window.scrollX,
bottom: rect.bottom + window.scrollY,
left: rect.left + window.scrollX
};
}
function setCustomProperty(property, value) {
document.documentElement.style.setProperty(property, value);
}
function setRootCustomProperties() {
const setCustomProperty = (property, value) => {
document.documentElement.style.setProperty(property, value);
};
if (sectionsOfHeaderGroup.length > 0) {
const totalHeight = Array.from(sectionsOfHeaderGroup).reduce((sum, section) => {
return sum + section.offsetHeight;
}, 0);
document.documentElement.style.setProperty('--header-group-height', `${totalHeight - 1}px`);
}
let headerHeight = 0;
if (header && isHeaderSticky) {
headerHeight = header.getBoundingClientRect().height.toFixed(2);
}
setCustomProperty("--header-height", `${parseFloat(headerHeight)}px`);
let cartDrawerBody = document.querySelector(".cart-drawer__body");
if (cartDrawerBody) {
setCustomProperty("--cart-drawer-body-width", `${parseFloat(cartDrawerBody.offsetWidth)}px`);
setCustomProperty("--cart-drawer-body-height", `${parseFloat(cartDrawerBody.offsetHeight)}px`);
}
if (productMedia) {
setCustomProperty("--product-media-area-width", `${parseFloat(productMedia.offsetWidth)}px`);
}
function setInitalProductMediaAreaHeight() {
if (productMedia && body.classList.contains("template--product")) {
let initialProductMediaAreaHeight = 0;
const mainTop = getCoordinates(main).top;
const productMediaTop = getCoordinates(productMedia).top;
const productTopbar = document.querySelector('.product__topbar-nav');
let productTopbarHeight = 0;
if (productTopbar) productTopbarHeight = productTopbar.offsetHeight;
initialProductMediaAreaHeight = window.innerHeight - Math.round(mainTop) - 2 * Math.round(productMediaTop - mainTop) + Math.round(productTopbarHeight);
const productSectionIndex = Array.prototype.indexOf.call(main.children, document.querySelector('main section.main-product'));
if (productSectionIndex > 0) {
initialProductMediaAreaHeight = window.innerHeight - Math.round(mainTop) - 2 * Math.round(productMediaTop - mainTop) + Math.round(productTopbarHeight);
}
initialProductMediaAreaHeight = Math.round(initialProductMediaAreaHeight - 24);
setCustomProperty("--product-media-area-height", initialProductMediaAreaHeight + "px");
}
}
function setInitalProductMediaSwiperAreaHeight() {
const sliderWrapper = document.querySelector('.main-product__media--slider-wrapper');
if (!sliderWrapper) return;
setCustomProperty(
"--product-media-area-swiper-height",
`${parseInt(sliderWrapper.offsetHeight)}px`
);
}
document.addEventListener("DOMContentLoaded", setInitalProductMediaAreaHeight);
window.addEventListener("resize", setInitalProductMediaAreaHeight);
document.addEventListener("DOMContentLoaded", setInitalProductMediaSwiperAreaHeight);
window.addEventListener("resize", setInitalProductMediaSwiperAreaHeight);
if (productMedia) {
const observer = new MutationObserver(() => {
setInitalProductMediaAreaHeight();
setInitalProductMediaSwiperAreaHeight();
});
observer.observe(productMedia, { childList: true, subtree: true });
}
if (Shopify.designMode) {
window.addEventListener('shopify:section:load', setInitalProductMediaSwiperAreaHeight);
}
if (heroBanner) {
setCustomProperty("--hero-banner-top", `${parseFloat(getCoordinates(heroBanner).top)}px`);
setCustomProperty("--hero-banner-bottom", `${parseFloat(getCoordinates(heroBanner).bottom)}px`);
}
const articleHeroMedia = document.querySelector(".js-article-hero-media");
const articleContent = document.querySelector(".js-article-content");
if (articleHeroMedia || articleContent) {
let socialShareStickyTop = 0;
let socialShareStickyStart = 0;
let headerBottom = parseInt(header?.getBoundingClientRect().bottom || 0);
if (articleHeroMedia) {
socialShareStickyTop = parseInt(articleHeroMedia.getBoundingClientRect().top);
socialShareStickyStart = parseInt(articleHeroMedia.getBoundingClientRect().right);
} else {
socialShareStickyTop = parseInt(articleContent.getBoundingClientRect().y);
socialShareStickyStart = parseInt(articleContent.getBoundingClientRect().right);
}
if (socialShareStickyTop < (0 + headerBottom)) {
socialShareStickyTop = headerBottom;
}
setCustomProperty(
"--social-share-sticky-top",
`${socialShareStickyTop}px`
);
setCustomProperty(
"--social-share-sticky-start",
`${socialShareStickyStart}px`
);
}
if (heroBanner) {
let heroInner = heroBanner.querySelectorAll(".hero__inner");
if (heroInner.length > 0) {
let heroInnerFirst = heroInner[0];
let headerMenuTextColor = heroInnerFirst.getAttribute("data-header-menu-text-color");
if (headerMenuTextColor) {
setCustomProperty(
"--transparent-header-menu-text-color", `${headerMenuTextColor}`
);
}
}
} else {
setCustomProperty(
"--transparent-header-menu-text-color", `var(--color-background)`
);
}
if (productCardMedia) {
setCustomProperty(
"--product-card-media-height",
`${parseInt(productCardMedia.offsetHeight)}px`
);
}
}
function scrollPositionY() {
setCustomProperty("--window-scroll-y-position", window.scrollY);
if (window.scrollY === 0) {
document.body.classList.add('is-at-top');
document.body.classList.remove('is-scrolled');
} else {
document.body.classList.add('is-scrolled');
document.body.classList.remove('is-at-top');
}
}
scrollPositionY();
window.addEventListener("scroll", scrollPositionY);
const bodyScroll = {
lock(container) {
bodyScrollLock.disableBodyScroll(container);
},
unlock(container) {
bodyScrollLock.enableBodyScroll(container);
},
clear() {
bodyScrollLock.clearAllBodyScrollLocks();
}
};
const onKeyUpEscape = event => {
if (event.code.toUpperCase() !== "ESCAPE") return;
const openDetailsElement = event.target.closest("details[open]");
if (!openDetailsElement) return;
const summaryElement = openDetailsElement.querySelector("summary");
openDetailsElement.removeAttribute("open");
summaryElement.setAttribute("aria-expanded", false);
summaryElement.focus({
preventScroll: true
});
};
const getFocusableElements = container => {
return Array.from(
container.querySelectorAll(
'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
)
);
};
document
.querySelectorAll('[id^="Details-"] summary')
.forEach(summary => {
summary.setAttribute("role", "button");
summary.setAttribute(
"aria-expanded",
summary.parentNode.hasAttribute("open")
);
if (summary.nextElementSibling.getAttribute("id")) {
summary.setAttribute(
"aria-controls",
summary.nextElementSibling.id
);
}
summary.addEventListener("click", event => {
event.currentTarget.setAttribute(
"aria-expanded",
!event.currentTarget.closest("details").hasAttribute("open")
);
});
if (summary.closest("header-drawer")) return;
summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
const removeTrapFocus = (elementToFocus = null) => {
document.removeEventListener("focusin", trapFocusHandlers.focusin);
document.removeEventListener(
"focusout",
trapFocusHandlers.focusout
);
document.removeEventListener("keydown", trapFocusHandlers.keydown);
if (elementToFocus)
elementToFocus.focus({
preventScroll: true
});
};
const trapFocus = (container, elementToFocus = container) => {
var elements = getFocusableElements(container);
var first = elements[0];
var last = elements[elements.length - 1];
removeTrapFocus();
trapFocusHandlers.focusin = event => {
if (
event.target !== container &&
event.target !== last &&
event.target !== first
)
return;
document.addEventListener("keydown", trapFocusHandlers.keydown);
};
trapFocusHandlers.focusout = function () {
document.removeEventListener(
"keydown",
trapFocusHandlers.keydown
);
};
trapFocusHandlers.keydown = function (event) {
if (event.code.toUpperCase() !== "TAB") return; 
if (event.target === last && !event.shiftKey) {
event.preventDefault();
first.focus();
}
if (
(event.target === container || event.target === first) &&
event.shiftKey
) {
event.preventDefault();
last.focus();
}
};
document.addEventListener("focusout", trapFocusHandlers.focusout);
document.addEventListener("focusin", trapFocusHandlers.focusin);
elementToFocus.focus();
};
const serializeForm = form => {
const obj = {};
const formData = new FormData(form);
for (const key of formData.keys()) {
obj[key] = formData.get(key);
}
return JSON.stringify(obj);
};
const deepClone = obj => {
return JSON.parse(JSON.stringify(obj));
};
const handleize = str => str.replace(/[ \/_]/g, "-").toLowerCase();
const decode = str => decodeURIComponent(str).replace(/\+/g, " ");
const getOffsetTop = element => {
let offsetTop = 0;
do {
if (!isNaN(element.offsetTop)) {
offsetTop += element.offsetTop;
}
} while ((element = element.offsetParent));
return offsetTop;
};
class MenuDrawer extends HTMLElement {
constructor() {
super();
this.details = this.querySelector("details");
this.summary = this.querySelector("summary");
this.drawer = this.querySelector(".js-drawer");
this.btnsCloseDrawer = this.querySelectorAll(
".js-btn-close-drawer"
);
this.btnsCloseDrawer = [...this.btnsCloseDrawer].filter(
btnCloseDrawer =>
this.drawer === btnCloseDrawer.closest(".js-drawer")
);
this.elementToFocus =
this.querySelector(".js-drawer-focus-element") ||
this.btnsCloseDrawer[0];
this.toggleButtons = [this.summary, ...this.btnsCloseDrawer];
this.isParentDrawerOpen = false;
this.predictiveSearch = this.querySelector("predictive-search");
this.HeaderDrawer = document.querySelector("header-drawer");
this.setInitialAccessibilityAttr();
this.toggleButtons.forEach(toggleButton => {
toggleButton.addEventListener("click", e => {
e.preventDefault();
this.toggleDrawer();
});
});
this.addEventListener("keydown", e => {
const isEscapeKey = e.key === "Escape";
const isDrawerOpen =
this.details.classList.contains("menu-opening");
const nestedOpenDrawer =
this.details.querySelector("details[open]");
if (!isEscapeKey || nestedOpenDrawer || !isDrawerOpen) {
return;
}
if (
this.predictiveSearch &&
this.predictiveSearch.input == document.activeElement
) {
return;
}
this.toggleDrawer();
});
this.toggleTrapFocus();
}
toggleDrawer() {
const isDetailsOpen = this.details.hasAttribute("open");
const headerDiv = document.getElementById("header");
if (!isDetailsOpen) {
this.details.setAttribute("open", "");
this.toggleButtons.forEach(toggleButton => {
toggleButton.classList.add("menu-is-open");
toggleButton.setAttribute("aria-expanded", true);
});
this.details.classList.add("menu-opening");
headerDiv.classList.add("menu-open");
const bodyHasOverflow = body.style.overflow === "hidden";
if (bodyHasOverflow) {
this.parentDrawer = this.closest(".js-drawer");
if (this.parentDrawer) {
this.isParentDrawerOpen = true;
}
} else {
body.style.overflow = "hidden";
body.classList.add("drawer--is-open");
body.style.width = "100%";
}
var searchInput = this.querySelector("#search-desktop");
if (searchInput) {
searchInput.focus();
if (headerDiv) {
headerDiv.classList.remove("menu-open");
}
}
} else {
this.details.classList.remove("menu-opening");
this.toggleButtons.forEach(toggleButton => {
toggleButton.classList.remove("menu-is-open");
toggleButton.setAttribute("aria-expanded", false);
});
const header = document.getElementById('header');
const navDrawerHeader = header ? header.querySelector('#Navigation-drawer-header') : null;
if (navDrawerHeader && navDrawerHeader.classList.contains('menu-opening')) {
body.style.overflow = 'hidden';
} else {
body.style.overflow = '';
body.style.top = '';
body.style.width = '';
body.classList.remove('drawer--is-open');
}
if (this.isParentDrawerOpen) {
this.parentDrawer.style.overflow = "";
}
setTimeout(() => {
this.details.removeAttribute("open");
}, 500);
}
const handleDropdownTransition = e => {
if (
e.target !== this.drawer ||
e.propertyName !== "visibility"
) {
return;
}
this.details.classList.remove("drawer-transitioning");
if (this.elementToFocus) {
this.elementToFocus.focus({
preventScroll: true
});
}
const isDetailsOpen = this.details.hasAttribute("open");
if (!isDetailsOpen) {
this.toggleButtons.forEach(toggleButton => {
toggleButton.setAttribute("aria-expanded", false);
});
this.summary.focus({
preventScroll: true
});
}
if (this.isParentDrawerOpen) {
this.parentDrawer.style.overflow = "";
document.body.style.overflow = "";
} else {
document.body.style.overflow = "hidden";
}
e.target.removeEventListener(
"transitionend",
handleDropdownTransition
);
};
this.drawer.addEventListener(
"transitionstart",
e => {
this.details.classList.add("drawer-transitioning");
},
{
once: true
}
);
this.drawer.addEventListener(
"transitionend",
handleDropdownTransition
);
}
closeAllOtherDrawers() {
const allDrawers = document.querySelectorAll(".js-drawer");
allDrawers.forEach(drawer => {
const details = drawer.closest("details");
if (details && details !== this.details) {
details.removeAttribute("open");
drawer.style.overflow = "";
}
});
document.body.style.overflow = "";
}
instantlyHideDrawer() {
this.toggleButtons.forEach(toggleButton => {
toggleButton.setAttribute("aria-expanded", false);
});
this.details.classList.remove("menu-opening");
this.details.removeAttribute("open");
body.style.overflow = "";
}
toggleTrapFocus(container = this.drawer) {
let isHandlingFocus = false;
document.addEventListener("focusin", e => {
if (isHandlingFocus) return;
isHandlingFocus = true;
const isDrawerOpen =
this.details.classList.contains("menu-opening");
if (!isDrawerOpen) {
isHandlingFocus = false;
return;
}
const openDrawer = e.target.closest(
"details.menu-opening .js-drawer"
);
const nestedOpenDrawer = this.details.querySelector(
"details.menu-opening"
);
if (openDrawer === this.drawer || nestedOpenDrawer) {
isHandlingFocus = false;
return;
}
e.preventDefault();
const focusableElements = getFocusableElements(container);
const focusedElementDOMPosition =
container.compareDocumentPosition(e.target);
const visibleFocusableElements = focusableElements.filter(
focusableElement => {
const isHidden =
getComputedStyle(focusableElement).display === "none";
if (isHidden) {
return;
}
const isSummary = focusableElement.tagName === "SUMMARY";
const focusableElementDetails =
focusableElement.closest("details");
const parentFocusableElementDetails =
focusableElementDetails.parentElement.closest("details");
const focusableElementDrawer =
focusableElementDetails.querySelector(".js-drawer");
const isThisDrawerOrDetails = focusableElementDrawer
? focusableElementDrawer === this.drawer
: focusableElementDetails === this.details;
return (
isThisDrawerOrDetails ||
(isSummary &&
parentFocusableElementDetails.hasAttribute("open"))
);
}
);
const firstFocusableElement = visibleFocusableElements[0];
const lastFocusableElement =
visibleFocusableElements[visibleFocusableElements.length - 1];
if (focusedElementDOMPosition >= 4) {
firstFocusableElement.focus({
preventScroll: true
});
} else {
lastFocusableElement.focus({
preventScroll: true
});
}
isHandlingFocus = false;
});
}
setInitialAccessibilityAttr() {
const isDetailsOpen = this.details.hasAttribute("open");
this.summary.setAttribute("role", "button");
this.summary.setAttribute("aria-controls", this.drawer.id);
this.summary.setAttribute("aria-expanded", isDetailsOpen);
}
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
constructor() {
super();
window.addEventListener("resize", e => {
const isMobileDrawer = this.classList.contains("mobile-drawer");
if (!isMobileDrawer) {
return;
}
const isMenuOpen = this.details.classList.contains("menu-opening");
if (DeviceDetector.isMobile() || !isMenuOpen) {
return;
}
this.instantlyHideDrawer();
});
}
instantlyHideDrawer() {
super.instantlyHideDrawer();
}
toggleDrawer() {
const drawerButton = this.querySelector(".drawer__button");
if (drawerButton.classList.contains("menu-is-open")) {
header.classList.remove("menu-open");
drawerButton.classList.remove("menu-is-open");
body.style.removeProperty("position");
window.scrollTo(0, this.scrollTopValue);
} else {
this.scrollTopValue = window.scrollY;
header.classList.add("menu-open");
drawerButton.classList.add("menu-is-open");
}
super.toggleDrawer();
this.querySelectorAll(".drawer__menu-item").forEach(item => {
item.classList.toggle("is--visible");
});
this.querySelectorAll(".drawer__subnav-item").forEach(item => {
item.classList.toggle("is--visible");
});
}
toggleTrapFocus() {
super.toggleTrapFocus(this.details);
}
}
customElements.define("header-drawer", HeaderDrawer);
class DesktopDrawer extends MenuDrawer {
constructor() {
super();
window.addEventListener("resize", e => {
const isMenuOpen = this.details.classList.contains("menu-opening");
if (!DeviceDetector.isMobile() || !isMenuOpen) {
return;
}
this.instantlyHideDrawer();
});
}
}
customElements.define("desktop-drawer", DesktopDrawer);
class SearchDrawer extends MenuDrawer {
constructor() {
super();
window.addEventListener("resize", e => {
const isMenuOpen =
this.details.classList.contains("menu-opening");
if (!isMenuOpen) {
return;
}
});
this.btn = this.querySelector(".drawer__button");
this.btn.addEventListener("click", () => {
const headerDrawerDetails = document.querySelector("header-drawer details");
if (headerDrawerDetails) {
headerDrawerDetails.removeAttribute("open");
headerDrawerDetails.classList.remove("menu-opening");
}
});
}
}
customElements.define("search-drawer", SearchDrawer);
class CountryDrawer extends MenuDrawer {
constructor() {
super();
}
connectedCallback() {
const triggers = document.querySelectorAll('[id^="country-drawer-button"]');
if (triggers) {
triggers.forEach(trigger => {
trigger.addEventListener("click", (e) => {
e.preventDefault();
this.toggleDrawer();
});
});
} else {
}
}
}
customElements.define("country-drawer", CountryDrawer);
function pauseAllMedia() {
document.querySelectorAll(".js-youtube").forEach(video => {
video.contentWindow.postMessage(
'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
"*"
);
});
document.querySelectorAll(".js-vimeo").forEach(video => {
video.contentWindow.postMessage('{"method":"pause"}', "*");
});
document.querySelectorAll("video").forEach(video => video.pause());
document.querySelectorAll("product-model").forEach(model => {
if (model.modelViewerUI) model.modelViewerUI.pause();
});
}
function unpauseAllMedia() {
document.querySelectorAll(".js-youtube").forEach(video => {
video.contentWindow.postMessage(
'{"event":"command","func":"' + "playVideo" + '","args":""}',
"*"
);
});
document.querySelectorAll(".js-vimeo").forEach(video => {
video.contentWindow.postMessage('{"method":"play"}', "*");
});
document.querySelectorAll("video").forEach(video => {
let playPromise = video.play();
if (playPromise !== undefined) {
playPromise
.then(_ => {
})
.catch(error => {
video.play();
});
} else {
}
});
document.querySelectorAll("product-model").forEach(model => {
if (model.modelViewerUI) model.modelViewerUI.play();
});
}
const debounce = (fn, wait) => {
let t;
return (...args) => {
clearTimeout(t);
t = setTimeout(() => fn.apply(this, args), wait);
};
};
const fetchConfig = (type = "json") => {
return {
method: "POST",
headers: {
"Content-Type": `application/${type}`,
"Accept": `application/${type}`
}
};
};
class QuantityInput extends HTMLElement {
constructor() {
super();
this.input = this.querySelector("input");
this.changeEvent = new Event("change", { bubbles: true });
this.querySelectorAll("button").forEach(button =>
button.addEventListener("click", this.onButtonClick.bind(this))
);
}
onButtonClick(event) {
event.preventDefault();
const eventTarget = event.target.name
? event.target
: event.target.closest("button");
const previousValue = this.input.value;
eventTarget.name === "increment"
? this.input.stepUp()
: this.input.stepDown();
if (previousValue !== this.input.value)
this.input.dispatchEvent(this.changeEvent);
}
}
customElements.define("quantity-input", QuantityInput);
class ModalOpener extends HTMLElement {
constructor() {
super();
const button = this.querySelector("button");
if (!button) return;
button.addEventListener("click", () => {
const modal = document.querySelector(
this.getAttribute("data-modal")
);
if (modal) modal.show(button);
});
}
}
customElements.define("modal-opener", ModalOpener);
class ModalDialog extends HTMLElement {
constructor() {
super();
this.dialogHolder = this.querySelector('[role="dialog"]');
this.querySelector('[id^="ModalClose-"]').addEventListener(
"click",
this.hide.bind(this, false)
);
this.addEventListener("keyup", event => {
if (event.code?.toUpperCase() === "ESCAPE" && !event.target.closest("age-verification-popup")) {
this.hide();
}
});
this.addEventListener("click", event => {
if (event.target === this && !event.target.closest("age-verification-popup")) {
this.hide();
}
});
this.dialogHolder.addEventListener("click", event => {
event.stopPropagation();
});
}
connectedCallback() {
if (this.moved) return;
this.moved = true;
document.body.appendChild(this);
}
show(opener) {
this.openedBy = opener;
bodyScroll.lock(this.dialogHolder);
this.setAttribute("open", "");
trapFocus(this, this.dialogHolder);
window.pauseAllMedia();
}
hide() {
bodyScroll.unlock(this.dialogHolder);
document.body.dispatchEvent(new CustomEvent("modalClosed"));
this.removeAttribute("open");
removeTrapFocus(this.openedBy);
window.unpauseAllMedia();
}
}
customElements.define("modal-dialog", ModalDialog);